import React, {ComponentType} from "react";
import TableSeater from "shared-components/table-seater/alt-version";
import {IProps, IHandlers, classPrefix, ITableSeaterContainerProps} from 'shared-components/table-seater/types';
import {uniqueCssClassPrefix} from "app/diary.module.helpers";


/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import TableSelectionService from "external-services/table-selection-service/index";

const NS = 'TableSeaterContainer';


// const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<ITableSeaterContainerProps>();



const TableSeaterWrap = (all: IProps & ITableSeaterContainerProps & IHandlers) => {


  /**
   * Needed to get unique class names each time because there is a risk of class name clashes between different
   * instances of the same component. They use a counter to generate uniqueness, but this starts at 0 for each
   * component and therefore needs some other unique prefix, other than just the static 'classPrefix'.
   * Generating it on each render is a bit overkill, but there is no reliable way to get an id for each instance.
   */
  const uniqueClassPrefix = `${classPrefix}-${uniqueCssClassPrefix()}`;

  const {props, handlers} = TableSelectionService.getTableSeaterProps(all);
  props.classPrefix = uniqueClassPrefix;

  return ReactUtilsService.containerWrap(
    <TableSeater {...props} {...handlers} />, uniqueClassPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ATableSeater: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(TableSeaterWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
];
